import { linkClick, trackSearch } from '../metrics/metricAction';
import { store } from '../store/configureStore';
import { fireActionTriggerCustomEvent } from 'src/helpers/adobeCustomEvents';

export const trackClickAnalytics = (e, name, identifier) => {
  window.digitaldata.onclick.event = name;
  window.digitaldata.component.link.linkIdentifier = identifier;
  window.digitaldata.page.linkName = name;
  let detail = {
    linkName: name,
    linkIdentifier: identifier,
  };

  fireActionTriggerCustomEvent(e.target, detail);
  store.dispatch(linkClick(detail));
};

export const trackSearchAnalytics = (e, page) => {
  window.digitaldata.page.searchVertical = page;
  let detail = {
    searchVertical: page,
  };

  fireActionTriggerCustomEvent(e.target, detail);
  store.dispatch(trackSearch(detail));
};
